import { createReducer } from '@reduxjs/toolkit';

import {
  ActionSuccessType,
  GET_ACCOUNT_SETTINGS,
  UPDATE_USER_PREFERENCES,
  UPDATE_USER_PROFILE,
  CREATE_PAYMENT_METHOD,
  UPDATE_USER_TERMS_SETTING,
  UPDATE_PAYMENT_METHOD,
} from 'constants/redux-actions';

const initState = {};

const accountSettingsReducer = createReducer(initState, {
  [ActionSuccessType(GET_ACCOUNT_SETTINGS)]: (_, action) => action.payload.data,
  [ActionSuccessType(UPDATE_USER_PROFILE)]: (prevState, action) => ({ ...prevState, ...action.payload.data }),
  [ActionSuccessType(UPDATE_USER_PREFERENCES)]: (prevState, action) => ({ ...prevState, ...action.payload.data }),
  [ActionSuccessType(CREATE_PAYMENT_METHOD)]: (prevState, action) => ({ ...prevState, ...action.payload.data }),
  [ActionSuccessType(UPDATE_PAYMENT_METHOD)]: (prevState, action) => ({ ...prevState, ...action.payload.data }),
  [ActionSuccessType(UPDATE_USER_TERMS_SETTING)]: (prevState, action) => ({ ...prevState, ...action.payload.data }),
});

export default accountSettingsReducer;
